<div class="centera">
	<ion-button class="ion-no-padding btn-ctct" (click)="action()" [ngClass]="params.cssClass" color="action-button"
		slot="icon-only" [fill]="params.fill ? params.fill : 'solid'" data-cy="action-button" [shape]="params.shape">
		<ion-icon class="txt24px" [name]="params.icon"></ion-icon>
	</ion-button>
	<ion-note *ngIf="params.label" class="action-button-text">{{params.label}}</ion-note>
</div>